import qrSVG from '@zappar/mobile-only/lib/qrSVG';
import React, { memo, useLayoutEffect, useRef } from 'react';
import * as CSS from './QrCode.scss';

interface IParentProps {
	webUrl: string;
}

const QrCode: React.FC<IParentProps> = ({ webUrl }) => {
	const divRef = useRef<HTMLDivElement>(null);

	useLayoutEffect(() => {
		if (!divRef.current) return;
		divRef.current.innerHTML = qrSVG(webUrl);
	}, []);

	return <div className={CSS.SVGContainer} ref={divRef}></div>;
};

export default memo(QrCode);
